var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-bottom d-flex justify-content-end align-items-center m-3 ml-auto",attrs:{"id":"contact-area"}},[(_vm.isScrollMounted)?_c('span',{staticClass:"mr-1 animated fadeIn"},[_c('fab',{attrs:{"bgColor":_vm.bgColor,"actions":_vm.fabActions},on:{"fabEmail":_vm.fabEmail,"fabPhone":_vm.fabPhone}})],1):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3339c74d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ContactAreaButton.vue
// module id = XrIK
// module chunks = 0